export const embeddingReducerPath = 'embedding';
